"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Toast_1 = __importDefault(require("shared/components/Toast/Toast"));
var HoCs_1 = require("utils/HoCs");
var fullServiceStats_1 = require("utils/hooks/fullServiceStats");
var single_1 = require("utils/selectors/single");
var DashboardOverview_1 = __importDefault(require("./DashboardOverview"));
var SpendStats_1 = __importDefault(require("./SpendStats"));
var Dashboard = function () {
    var _a, _b;
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var _c = __read((0, fullServiceStats_1.useGetFullServiceStatsForProfile)(), 1), serviceStatsWithExtras = _c[0];
    var location = (0, react_router_1.useLocation)();
    if (!company) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Home", description: "Home page" }), (0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: 1000, mt: 1, mb: 2, mx: "auto" }, { children: [(0, jsx_runtime_1.jsx)(SpendStats_1.default, { serviceStatWithService: serviceStatsWithExtras }), (0, jsx_runtime_1.jsx)(DashboardOverview_1.default, { serviceStatWithService: serviceStatsWithExtras })] })) })), (0, jsx_runtime_1.jsx)(Toast_1.default, { message: (_a = location.state) === null || _a === void 0 ? void 0 : _a.toast, open: !!((_b = location.state) === null || _b === void 0 ? void 0 : _b.toast) })] }));
};
exports.default = react_1.default.memo((0, HoCs_1.HasCompanyHoC)(Dashboard));
